import { Paper, PaperProps, styled } from "@mui/material";
import { pageHeaderHeight } from "../../styles/theme";

export const PageHeaderPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.light,
  boxShadow: "none",
  color: theme.palette.primary.contrastText,
  display: "inline-block",
  height: `${pageHeaderHeight}px`,
  zIndex: "999",
  borderRadius: "0px",
})) as React.ComponentType<PaperProps>;
